import React from "react";
import { postSMDData, postSMDAttachment } from "../Actions/SMDNewEditItem";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import $ from "jquery";
toast.configure();
class SMDNewItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            SMDPostArray: { companyName: '', attachmentName: '', attachmentGuid: '', createdBy: '' },
            file: '',
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.SubmitSMDData = this.SubmitSMDData.bind(this);
    }
    // static getDerivedStateFromProps(nextProps, prevState) {
    //     const { dispatch } = nextProps;
    //     if (nextProps.SMDAttachmentData !== '' && nextProps.SMDAttachmentData !== prevState.SMDAttachmentData) {
    //         prevState.SMDAttachmentData = nextProps.SMDAttachmentData;
    //         prevState.SMDPostArray.attachmentName = nextProps.SMDAttachmentData.FileName;
    //         prevState.SMDPostArray.attachmentGuid = nextProps.SMDAttachmentData.Guid;
    //         prevState.SMDPostArray.createdBy = nextProps.userDisplayName;
    //         dispatch(postSMDData(prevState.SMDPostArray));
    //     }
    //     if (nextProps.IsSMDDataAdded && nextProps.IsSMDDataAdded !== undefined) {
    //         nextProps.history.push('/Home/SMDLibray');
    //         dispatch({type:"SMDAttchmentClear"})
    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { SMDAttachmentData, dispatch } = nextProps;
        if (SMDAttachmentData && SMDAttachmentData !== "") {
            prevState.SMDPostArray.attachmentName = SMDAttachmentData.FileName;
            prevState.SMDPostArray.attachmentGuid = SMDAttachmentData.Guid;
            prevState.file = '';
            dispatch({ type: "SMDAttchmentUploadSuccess", data: "" })
        }
    }

    CancelSMD() {
        this.props.history.push('/Home/SMDLibray');
    }


    handleInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "fileName") {
            e.target.files[0].name.trim() !== "" ? $("#SMDFileErrMsg").text("") : $("#SMDFileErrMsg").text("This field is required");
            this.state.SMDPostArray.attachmentName = e.target.files[0].name;
            this.state.file = e.target.files[0];
            this.setState({ SMDPostArray: this.state.SMDPostArray });
            this.props.dispatch(postSMDAttachment(e.target.files[0]));
           
        } else {
            e.target?.value.trim() !== "" ?  $("#SMDNameErrMsg").text("") :  $("#SMDNameErrMsg").text("This field is required");
            this.state.SMDPostArray[nodeName] = e.target.value;
            this.setState({});
        }
    }

    // handleInputFileChange(e) {
    //     e.preventDefault();
    //     let file = e.target.files[0];
    //     this.state.SMDPostArray.attachmentName = e.target.files[0].name;
    //     this.setState({ file: file });
    // }

    SubmitSMDData() {
        if (this.state.SMDPostArray.attachmentName.trim() == "" || this.state.SMDPostArray.companyName.trim() == ""){
            this.state.SMDPostArray.companyName.trim() == "" ? $("#SMDNameErrMsg").text("This field is required") : $("#SMDNameErrMsg").text("");
            this.state.SMDPostArray.attachmentName.trim() == "" ? $("#SMDFileErrMsg").text("This field is required") : $("#SMDFileErrMsg").text("");
        } else {
            $("#SMDNameErrMsg").text("");
            $("#SMDFileErrMsg").text("");
            const { dispatch, history } = this.props;
            dispatch(postSMDData(this.state.SMDPostArray));
            history.push('/Home/SMDLibray');
        }
            // this.state.ServiceProviderInfo.name === ""
        // ? $("#NameErrMsg").text("This field is required")
        // : $("#NameErrMsg").text("");
    }

    ClearInput() {
        let clearData = { FileName: "", Guid: "" }
        this.props.dispatch({
            type: "SMDAttchmentUploadSuccess",
            data: clearData,
        })
        $("#SMDFileErrMsg").text("This field is required");
    }

    render() {
        return (
            <div className="full-height w-100">
                <div className="grey-bg  course-list-page pt-3">
                    <div className="px-4">
                        <div className="panel-box search-filter-box mb-4">
                            <div className="row" style={{ paddingBottom: '12px' }}>
                                <div className="col-lg-6">
                                    <label className="form-label required" >Company Name</label><br></br>
                                    <input className="form-control" type="text" name="companyName" onChange={(e) => this.handleInputChange(e)} value={this.state.SMDPostArray.companyName}></input>
                                    <span id="SMDNameErrMsg" className="spanErrMsg ml-2"></span>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label required" >File</label><br></br>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Browse File<input type="file"  style={{ marginRight: 40 }} id="files" title=" " name="fileName" onChange={(e) => this.handleInputChange(e)} /></span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="No file chosen" value={this.state.SMDPostArray.attachmentName} />
                                        {
                                            this.state.SMDPostArray.attachmentName ?
                                                <div class="input-group-append" style={{cursor:"pointer"}}>
                                                    <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInput()}></i>
                                                </div> : ''
                                        }

                                    </div>
                                    <span id="SMDFileErrMsg" className="spanErrMsg ml-2"></span>
                                </div>

                                <div className="col-lg-12">
                                    <label className="form-label" ></label><br></br>
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.SubmitSMDData()}> Submit </button>

                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.CancelSMD()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        SMDAttachmentData: state.SidePanReducer.SMDAttachmentData,
        userDisplayName: state.SidePanReducer.userDisplayName,
        IsSMDDataAdded: state.SidePanReducer.IsSMDDataAdded
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SMDNewItem));